<template>
    <div>
        <small class="text-muted">
            <span class="field" v-if="isSameUser">
                {{ $t('feed.fields.you') }}
            </span>
            <b-link :to="`/v2/profile/${post.user.id}`" v-else>
                {{ post.user.name }}
            </b-link>
            <template v-if="postType(post.artifact_type)">
                <span v-if="post.artifact_type == 'checkin'"> {{ $t(`feed.type.checkin.${post.operation}`) }}: </span>
                <span v-else>
                    {{ $t(`feed.operations.${post.operation}`) }}
                    {{ postType(post.artifact_type) }}:
                </span>
            </template>
            <template v-else>{{ $t(`feed.operations.${post.operation}`) }}:</template>
        </small>
        <small class="text-muted float-right mt-1">{{ createdAt }}</small>
    </div>
</template>

<script>
import moment from 'moment'
import i18n from '@/i18n'
import { mapGetters } from 'vuex'

export default {
    name: 'PostHeader',
    props: {
        post: {
            type: Object,
            required: true,
        },
    },
    methods: {
        postType(artifactType) {
            const allowed = [
                'category',
                'value',
                'key_result',
                'objective',
                'goal',
                'checkin',
                'action_plan',
                'pda_checkin',
            ]

            if (artifactType)
                if (allowed.includes(artifactType)) {
                    return i18n.t(`feed.type.${artifactType}`)
                }
            return ''
        },
    },
    computed: {
        ...mapGetters(['getCurrentUser']),
        createdAt() {
            return moment(this.post.created_at).fromNow()
        },
        isSameUser() {
            return this.getCurrentUser.id == this.post.user.id
        },
    },
}
</script>

<style></style>
